angular.module('surfsightApp.controllers').controller('showLanguagesCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$mdMedia',
  'edgeFactory',
  'edgeGroupFactory',
  'broadcastViewFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  '$transitions',
  '$translate',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $mdMedia,
    edgeFactory,
    edgeGroupFactory,
    broadcastViewFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    $transitions,
    $translate1
  ) {
    var $translate = $filter('translate')
    $scope.events_list = []
    $scope.sideNav_list = []
    $scope.languageKey = $translate1.use()
    $scope.languagesList = window.languagesList
    if ($scope.languageKey == undefined) {
      $scope.language_code = 'EN'
      $scope.language_flag = 'flag-icon-us'
    }
    $scope.languagesList.forEach(function (lang) {
      if (lang.language_key == $scope.languageKey) {
        $scope.language_code = lang.lang_code
        $scope.language_flag = lang.flag
      }
    })
    $scope.showLanguages = function (ev) {
      $mdDialog
        .show({
          controller: 'languageController',
          templateUrl:
            './templates/language.change.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {
            $scope.language_code = response.lang_code
            $scope.language_flag = response.flag
          },
          function () {
            //
          }
        )
    }
    if ($localStorage.selectedLanguage != null) {
      $scope.language_code = $localStorage.selectedLanguage.lang_code
      $scope.language_flag = $localStorage.selectedLanguage.flag
      var language_key = $localStorage.selectedLanguage.language_key
      $translate1.use(language_key)
      moment.locale($scope.language_code.toLowerCase())
    }
  }
])
